import React, {Fragment} from 'react';
import {Form, Field} from 'react-final-form';
import {Popup, Text, Explanation_text, TextEditor} from '../../../components';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import {connect} from 'react-redux';

function Unsubscribe_message_popup(props){

  function onSubmit(params){
    props.updateUnsubscribeMessage(params);
  }

  return(
    <Form
      onSubmit={onSubmit}
      initialValues={props.gmail.unsubscribe_message}
    >
      {form_props => (
        <form onSubmit={form_props.handleSubmit}>
        <Popup handleClose={props.handleClose} accept_button='Save' accept_button_click={()=>{form_props.form.submit(); form_props.form.reset(); props.handleClose();}}  always_open title='Unsubscribe message' content={
          <div style={{width:'95vw', maxWidth:'600px', height:'320px'}}>
            <Grid container style={{width:'calc(100% - 40px)', marginLeft:'20px', marginTop:'20px'}}>
              <Grid item xs={12}><Text title="Title" name="title"/></Grid>
              <Grid item xs={12}>
                <div style={{width:'calc(100% - 20px)', marginLeft:'10px', marginTop:'10px'}}>
                  <Typography variant='contained'>Confirmation message</Typography>
                  <Field name='confirmation_message'>{(f)=>{return(<div style={{width:'100%'}}><TextEditor value={f.input.value} onChange={f.input.onChange} name='confirmation_message'/></div>)}}</Field>
                </div>
              </Grid>
              <Grid item xs={12}>
                <div style={{width:'calc(100% - 20px)', marginLeft:'10px', marginTop:'20px'}}>
                  <Typography variant='contained'>Success message</Typography>
                  <Field name='success_message'>{(f)=>{return(<div style={{width:'100%'}}><TextEditor value={f.input.value} onChange={f.input.onChange} name='success_message'/></div>)}}</Field>
                </div>
              </Grid>
            </Grid>
          </div>
        }/>
        </form>
      )}

    </Form>
  );
}


export default connect(ss, dd)(Unsubscribe_message_popup);

function ss(state){
  return{}
}

function dd(dispatch){
  return{
    updateUnsubscribeMessage:(params)=>{dispatch({type:'REQUEST_UPDATE_EMAIL_UNSUBSCRIBE_MESSAGE', payload:params})}
  }
}
